var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4142 16.4142C32.1953 15.6332 32.1953 14.3668 31.4142 13.5858L18.6863 0.857864C17.9052 0.0768156 16.6389 0.0768156 15.8579 0.857864C15.0768 1.63891 15.0768 2.90524 15.8579 3.68629L27.1716 15L15.8579 26.3137C15.0768 27.0948 15.0768 28.3611 15.8579 29.1421C16.6389 29.9232 17.9052 29.9232 18.6863 29.1421L31.4142 16.4142ZM0 17H30V13H0V17Z",
    fill: "#38B0DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTwo);
export default __webpack_public_path__ + "static/media/ArrowRightTwo.5be91140865c8e7db141eab4411d1bc1.svg";
export { ForwardRef as ReactComponent };